// removed by extract-text-webpack-plugin
module.exports = {"orderSummaryPayment":"_3EFs8","orderTotal":"_2YQhL","heading":"_3FngK","expandedDisplay":"_2SjEi","extraInfo":"_2I6qI","summaryItem":"_3BpkI","summaryItemLarge":"_15AR4","ownServiceBase":"_1DJme","ownsService":"_1PTKz"};


//////////////////
// WEBPACK FOOTER
// ./components/OrderSummaryPaymentScreen/styles.scss
// module id = 694
// module chunks = 0